<template>
  <div ref="container">
    <a-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:15%;height:50%;">
      <template slot="footer">
        <a-button type="primary" @click="handleOk">
          保存
        </a-button>
        <a-button key="back" @click="handleCancel">
          关闭
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-row class="form-row" :gutter="24">
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="包装规格">
                <a-select disabled v-model="form.packageSpecification" style="width: 100%;" v-show="false">
                  <a-select-option v-for="(item,index) in specList" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
                <span v-show="form.packageSpecification ? true : false">{{ form.packageSpecification }}级包装</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="24/1" v-show="this.codeType == 2 && !form.edit">

              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="GS1产品编码生成方式" name="gs1Code"  >
                <a-radio-group v-model="form.ifSelfGs1">
                  <a-radio value="1">自动生成</a-radio>
                  <a-radio value="0">手动录入</a-radio>
                </a-radio-group>

              </a-form-model-item>
              <a-form-model-item v-if="form.ifSelfGs1 == '0'" :labelCol="labelCol" :wrapperCol="wrapperCol" label="GS1产品编码" name="gs1Code" prop="gs1Code">
                <a-input style="width:90%" :disabled="(form.totalCodeSystem.includes('2') && form.id==null)? false : true" placeholder="请输入GS1产品编码" v-model="form.gs1Code" />
                <a-tooltip placement="right" title="GS1产品编码填写内容不含包装规格">
                  <a-icon type="question-circle" style="margin-left:10px" />
                </a-tooltip>
              </a-form-model-item>
            </a-col>
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品包装级别">
                <a-select placeholder="请选择产品包装级别" v-model="form.packageLevel" style="width: 100%;">
                  <a-select-option v-for="(item,index) in packLevelList" :key="index" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="本级包装内包含小一级相同产品标识的包装数量">
                <a-input v-model="form.packageNumber" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="包装内含小一级包装产品标识">
                <span>{{form.productDi}}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import { insertPackage, checkSupplier, updatePackage, getSpecification } from '@/api/api'
import { autoJumpNextInput } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'VendorModal',
  mixins: [JeecgListMixin, mixinDevice],
  data() {
    return {
      rules:{
        gs1Code: [{ required: true, message: 'GS1产品编码不能为空!' },{validator:this.validateGs1code}],
      },
      title: '333',
      codeSystem:'',
      codeType: '',
      visible: false,
      fileList: [],
      model: {},
      headers: { 'X-Access-Token': '123' },
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
      confirmLoading: false,
      form: {
        packageSpecification: '',
        packageNumber: undefined,
        packageLevel: undefined,
        productDi: '',
        totalCodeSystem:[],
        gs1Code:'',
        codeSystem:'',
        ifSelfGs1:'1'
      },
      specList: [
        {
          // 包装规格
          label: '初级包装',
          value: '0',
        },
        {
          label: '一级包装',
          value: '1',
        },
        {
          label: '二级包装',
          value: '2',
        },
        {
          label: '三级包装',
          value: '3',
        },
        {
          label: '四级包装',
          value: '4',
        },
        {
          label: '五级包装',
          value: '5',
        },
        {
          label: '六级包装',
          value: '6',
        },
        {
          label: '七级包装',
          value: '7',
        },
        {
          label: '八级包装',
          value: '8',
        },
        {
          label: '九级包装',
          value: '9',
        },
      ],
      packLevelList: [
        {
          // 包装级别
          label: '件',
          value: 0,
        },
        {
          label: '盒',
          value: 1,
        },
        {
          label: '箱',
          value: 2,
        },
      ],
      productDi: '',
    }
  },
  created() {},
  methods: {
    validateGs1code(rule, value, callback){
      if (value && (value.length < 13 || value.length > 14)) {
        callback('GS1产品编码长度不正确');
      } else {
        callback();
      }
    },
    resetForm() {
      this.form = {
        packageSpecification: '',
        packageNumber: undefined,
        packageLevel: undefined,
        productId: '',
        productDi: '',
        totalCodeSystem:[],
        gs1Code:'',
        codeSystem:'',
        ifSelfGs1:'1'
      }
    },
    async add(params) {
      this.codeType = params.codeSystem
      console.log(this.codeType,'看看添加包装传过来的编码类型是MA还是GSI')
      this.edit({})
      this.resetForm()
      if (params) {
        this.form.productId = params.id
        const res = await getSpecification({ productId: params.id,codeSystem: params.codeSystem })
        console.log(res, 'res123')
        if (res.errno == 200 && res.errmsg == '成功') {
          this.form.packageSpecification = res.data.specificationCode
          this.form.productDi = res.data.minSpecificationId
          this.form.totalCodeSystem=res.data.totalCodeSystem
          this.form.codeSystem = params.codeSystem;
        } else {
          this.$message.error(res.data || res.msg)
        }
      }
    },
    edit(record) {
      this.visible = true
      this.form = Object.assign(this.form, record)
      this.form.edit = true
      this.$nextTick(() => {})
    },

    close() {
      this.$emit('close')
      this.visible = false
    },
    async handleOk() {
      this.$refs.form.validate((err, values) => {
        if (err) {
          if (this.form.id) {
            updatePackage(this.form).then(res=>{
              if (res.errno == 200 && res.errmsg == '成功') {
                this.$message.success('修改成功')
                this.close()
              } else {
                this.$message.error(res.errmsg)
              }
            })
          } else {
            insertPackage(this.form).then(res=>{
              console.log(res, 'res')
              if (res.errno == 200 && res.errmsg == '成功') {
                this.$message.success('添加成功')
                this.close()
              } else {
                this.$message.error(res.errmsg)
              }
            })
          }
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateSupplierName(rule, value, callback) {
      let params = {
        name: value,
        type: '供应商',
        id: this.model.id ? this.model.id : 0,
      }
      checkSupplier(params).then((res) => {
        if (res && res.code === 200) {
          if (!res.data.status) {
            callback()
          } else {
            callback('名称已经存在')
          }
        } else {
          callback(res.data)
        }
      })
    },
  },
}
</script>
<style scoped>
</style>